import React, { useState } from "react";
import * as styles from "./hero.module.scss"
import { AnchorLink } from "gatsby-plugin-anchor-links";

import TwitterLogo from "../../../images/svgs/twitter.inline.svg"
import FacebookLogo from "../../../images/svgs/facebook.inline.svg"
import MailLogo from "../../../images/svgs/envelope.inline.svg"
import LinkLogo from "../../../images/svgs/link45deg.inline.svg"

const Hero = ({data, title, author, date, uri}) => {

    const [copied, setCopied] = useState(false);

    const url = typeof window !== 'undefined' ? window.location.href : '';

    const careers = url.includes("/careers/")

    let d = new Date(date)
    let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
    let month = new Intl.DateTimeFormat('en', { month: 'long' }).format(d)
    let day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)
    let formatedDate = `${month} ${day}, ${year}`

    const copy = () => {
        const el = document.createElement("input");
        el.value = window.location.href;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        setCopied(true);

        setTimeout(function() {
            setCopied(false);
        }, 2000)
    }

    return (
        <div className={styles.hero}>
            <div className="container">
                
                <div className="row">
                    <div className="col-lg-8 offset-lg-2">
                        {data.title ? 
                            <h1>{ data.title }</h1> : 
                            <h1>{ title }</h1>
                        }
                        {data.subtitle &&
                            <h3>{data.subtitle}</h3>
                        }
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-9 offset-lg-2">
                        <div className={styles.hero__meta}>
                            <div className={styles.hero__meta__left}>
                                {/* <p><span>{ author }</span> | <span>{ formatedDate }</span></p> */}
                                <p>{ formatedDate }</p>

                                <div className={styles.hero__meta__left__links}>
                                    <a className={styles.hero__meta__left__links__link} href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} target="_blank" rel="noreferrer" aria-label="Facebook">
                                        <FacebookLogo />
                                    </a>
                                    <a className={styles.hero__meta__left__links__link} href={`https://twitter.com/intent/tweet?url=${url}`} target="_blank" rel="noreferrer" aria-label="Twitter">
                                        <TwitterLogo />
                                    </a>
                                    <a className={styles.hero__meta__left__links__link} href={`mailto:?body=${url}`} aria-label="email">
                                        <MailLogo />
                                    </a>
                                    <button className={styles.hero__meta__left__links__link} onClick={copy} aria-label="copy">
                                        {copied && <span className={styles.copied__tooltip}>Copied to clipboard</span>}
                                        <LinkLogo />
                                    </button> 
                                </div>

                            </div>

                            <div className={styles.hero__meta__right}>
                                <AnchorLink to={`${uri}#contact`} title={careers ? "Apply now" : "Subscribe for resources"} />
                            </div>
                        </div>
                    </div>
                </div>

                {data.introduction &&
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <p className={styles.hero__introduction}>{ data.introduction }</p>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default Hero